// Admin reminder to tick "Status Kedatangan Dokter" for the running Praktek
// (in-clinic) shift. The backend resets shifts.doctor_arrival_status to 0 when
// a shift ends, so the next shift always starts unticked and staff forget to
// tick it at the shift change.

// How often the reminder modal comes back while the doctor is still unticked.
export const DOCTOR_ARRIVAL_REMINDER_MS = 10 * 60 * 1000;

// How often the admin panel asks the server for the running shift's status
// (getTodaysQueueInfo). Another admin PC ticking the checkbox is picked up
// within this time. react-query pauses polling while the tab is hidden and
// refetches as soon as the tab is focused again.
export const DOCTOR_ARRIVAL_POLL_MS = 60 * 1000;

// How often the browser re-checks whether a reminder is due (also re-checked on
// tab focus / visibilitychange, because background tabs throttle timers).
export const DOCTOR_ARRIVAL_RECHECK_MS = 5 * 1000;

// localStorage key prefix; the full key is `${prefix}:${shiftId}:${date}`.
export const DOCTOR_ARRIVAL_STORAGE_PREFIX = "doctor_arrival_reminder";

// window CustomEvent fired whenever the doctor arrival status is changed from
// the admin panel (the reminder or the Antrian Klinik checkbox), so every open
// view refreshes right away instead of waiting for its next poll.
export const DOCTOR_ARRIVAL_STATUS_CHANGED_EVENT =
  "doctor-arrival-status-changed";
